import React, { useState, useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import ModalHeader from "../../../common/ModalHeader";
import ModalFooter from "../../../common/ModalFooter";
import ModalBody from "../../../common/ModalBody";
import { useTranslation } from "react-i18next";
import Constants from "../../../../common/Constants";

const JobStatusModal = (props) => {
  let [jobstatusName, setJobstatusName] = useState("");
  let [edit, setEdit] = useState(false);
  let [id, setId] = useState("");
  const [validate, setValidate] = useState(false);
  let [jobStatus, setJobStatus] = useState("Active");
  const { t } = useTranslation();
  const formRef = useRef(null);

  useEffect(() => {
    if (props.data.jobstatusCode) {
      setJobstatusName(props?.data?.jobstatusName);
      setId(props?.data?.jobstatusCode);
      setJobStatus(props?.data?.jobStatus);
      setEdit(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSave = (event) => {
    const form = formRef.current;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidate(true);
      return;
    } else {
      setValidate(false);
      const jobStatusObj = {
        jobstatusName: jobstatusName,
        jobstatusCode: id,
        jobStatus: jobStatus,
      };
      if (edit) {
        jobStatusObj._id = props.data._id;
      }
      props.onSave(jobStatusObj, edit);
      setJobstatusName("");
      setId("");
      setEdit(false);
    }
  };

  const handleCancel = (event) => {
    setJobstatusName("");
    setId("");
    props.onHide();
  };

  const { show, onHide } = props;
  return (
    <Modal show={show} onHide={onHide} animation={false} backdrop="static">
      <ModalHeader
        title={edit ? t("msg_master_list.msg_jobstatus.edit_page_title") : t("msg_master_list.msg_jobstatus.page_title")}
      ></ModalHeader>
      <ModalBody>
        <Form noValidate validated={validate} ref={formRef}>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label className="col-form-label">
              {t("msg_master_list.msg_jobstatus.code")} :
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="e.g: JOB-001"
              value={id || ""}
              onChange={(e) => setId(e.target.value?.trim()?.toUpperCase())}
              required
              maxLength={Constants.MASTER.VALIDATION.maxLengthCode}
              autoFocus
            />
            <Form.Control.Feedback type="invalid">
              {t("msg_master_list.msg_jobstatus.jobstatus_code_validation")}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label className="col-form-label">
              {" "}
              {t("msg_master_list.msg_jobstatus.jobstatus_name")} :
            </Form.Label>
            <Form.Control
              type="text"
              value={jobstatusName || ""}
              onChange={(e) => setJobstatusName(e.target.value)}
              maxLength={Constants.MASTER.VALIDATION.maxLengthName}
              required
            />
            <Form.Control.Feedback type="invalid">
              {t("msg_master_list.msg_jobstatus.jobstatus_name_validation")}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label className="col-form-label">
              {t("msg_common.status")} :
            </Form.Label>
            <Form.Select
              aria-label="select status"
              value={jobStatus}
              onChange={(e) => setJobStatus(e.target.value)}
            >
              <option value="Active">{t("msg_common.active")}</option>
              <option value="Inactive">{t("msg_common.inactive")}</option>
            </Form.Select>
          </Form.Group>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          type="button"
          variant="success"
          className="btn btn-success"
          onClick={handleSave}
        >
          {t("msg_common.save")}
        </Button>
        <Button
          type="button"
          variant="danger"
          className="btn btn-danger"
          onClick={handleCancel}
          data-dismiss="modal"
        >
          {t("msg_common.cancel")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default JobStatusModal;
